import React, { useState, useEffect } from 'react';
import './Marketplace.css';

function Marketplace({ user }) {
  const [picks, setPicks] = useState([]);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [newPick, setNewPick] = useState({
    game: '',
    pick: '',
    odds: '',
    confidence: 'medium',
    analysis: '',
    price: 9.99
  });

  useEffect(() => {
    fetchPicks();
  }, []);

  const fetchPicks = async () => {
    try {
      const token = localStorage.getItem('idToken');
      const response = await fetch('https://fj7f90d436.execute-api.us-east-1.amazonaws.com/marketplace/picks', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      setPicks(data.picks || []);
    } catch (error) {
      console.error('Failed to fetch picks:', error);
    }
  };

  const createPick = async () => {
    try {
      const token = localStorage.getItem('idToken');
      await fetch('https://fj7f90d436.execute-api.us-east-1.amazonaws.com/marketplace/picks', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          ...newPick,
          createdAt: Date.now()
        })
      });
      
      setShowCreateForm(false);
      setNewPick({ game: '', pick: '', odds: '', confidence: 'medium', analysis: '', price: 9.99 });
      fetchPicks();
    } catch (error) {
      alert('Failed to create pick');
    }
  };

  const purchasePick = async (pickId) => {
    try {
      const token = localStorage.getItem('idToken');
      const response = await fetch('https://fj7f90d436.execute-api.us-east-1.amazonaws.com/marketplace/purchase', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ pickId })
      });
      
      const data = await response.json();
      alert('Purchase successful! Pick details: ' + JSON.stringify(data.pick, null, 2));
      fetchPicks();
    } catch (error) {
      alert('Purchase failed');
    }
  };

  return (
    <div className="marketplace">
      <div className="marketplace-header">
        <h2>Premium Picks Marketplace</h2>
        <button onClick={() => setShowCreateForm(!showCreateForm)} className="create-pick-btn">
          {showCreateForm ? 'Cancel' : '+ Create Pick'}
        </button>
      </div>

      {showCreateForm && (
        <div className="create-pick-form">
          <h3>Create Premium Pick</h3>
          <input
            type="text"
            placeholder="Game (e.g., Chiefs vs Bills)"
            value={newPick.game}
            onChange={(e) => setNewPick({...newPick, game: e.target.value})}
          />
          <input
            type="text"
            placeholder="Pick (e.g., Chiefs -3)"
            value={newPick.pick}
            onChange={(e) => setNewPick({...newPick, pick: e.target.value})}
          />
          <input
            type="number"
            placeholder="Odds (e.g., -110)"
            value={newPick.odds}
            onChange={(e) => setNewPick({...newPick, odds: e.target.value})}
          />
          <select
            value={newPick.confidence}
            onChange={(e) => setNewPick({...newPick, confidence: e.target.value})}
          >
            <option value="low">Low Confidence</option>
            <option value="medium">Medium Confidence</option>
            <option value="high">High Confidence</option>
          </select>
          <textarea
            placeholder="Analysis..."
            value={newPick.analysis}
            onChange={(e) => setNewPick({...newPick, analysis: e.target.value})}
            rows="4"
          />
          <input
            type="number"
            step="0.01"
            placeholder="Price ($)"
            value={newPick.price}
            onChange={(e) => setNewPick({...newPick, price: e.target.value})}
          />
          <button onClick={createPick}>Publish Pick</button>
        </div>
      )}

      <div className="picks-grid">
        {picks.map(pick => (
          <div key={pick.pickId} className="pick-card">
            <div className="pick-header">
              <span className="handicapper">{pick.handicapperName}</span>
              <span className={`confidence ${pick.confidence}`}>{pick.confidence}</span>
            </div>
            <div className="pick-game">{pick.game}</div>
            <div className="pick-selection">{pick.pick}</div>
            <div className="pick-odds">Odds: {pick.odds > 0 ? '+' : ''}{pick.odds}</div>
            {pick.analysis && <div className="pick-analysis">{pick.analysis}</div>}
            <div className="pick-footer">
              <span className="pick-price">${pick.price}</span>
              <span className="pick-purchases">{pick.purchases} purchases</span>
              <button onClick={() => purchasePick(pick.pickId)} className="purchase-btn">
                Buy Now
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Marketplace;
